import { Label } from '@/components/ui/label'
import { Skeleton } from '@/components/ui/skeleton'

export const NameFallback = () => (
  <div className="w-full">
    <Label>Display name</Label>
    <Skeleton className="h-9 w-full mt-2" />
    <Skeleton className="h-4 w-1/2 mt-2" />
  </div>
)
